import { SupplierTypeEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class IndentReportRequest {
    @ApiProperty()
    fromDate?: Date;
    @ApiProperty()
    toDate?: Date;
    @ApiProperty()
    indentCode?: number;
    @ApiProperty()
    harvestingDate?: Date;
    @ApiProperty()
    supplierType?: SupplierTypeEnum;
}